export const countUniqueCustomerCodes = (orders) => {
  const uniqueCodes = new Set();

  orders.forEach(order => {
    if (order.customerCode) {
      uniqueCodes.add(order.customerCode);
    }
  });

  return uniqueCodes.size;
}


export function convertAcresToTons(acres, code) {
  // Lookup table for tons per acre
  const conversionRates = {
    "0.25ACR": 0.25,
    "0.5ACR": 0.5,
    "0.75ACR": 0.75,
    "1ACR": 1,
    "1.25ACR": 1.25,
    "1.5ACR": 1.5,
    "2ACR": 2,
  };

  const tonsPerAcre = conversionRates[code];

  // If code not found, just exit (skip function)
  if (tonsPerAcre === undefined) {
    return; // or return null if you want an explicit value
  }

  return acres * tonsPerAcre;
}
